import "./polyfills";
import { createApp } from "vue";
import { createPinia, setActivePinia } from "pinia";
import naive from "naive-ui";
import { createWebHistory, createRouter } from "vue-router";

import { villusClient } from "./villusClient";
import App from "./App.vue";
import BookingHome from "./components/BookingHome.vue";
import BookingFunnel from "./components/BookingFunnel.vue";
import NoCenterAvailable from "./components/NoCenterAvailable.vue";

// vue-router setup
const routes = [
  {
    path: `/:lang([a-zA-Z-]+)?${import.meta.env.VITE_BASE_URL}/booking-search`,
    name: "BookingHome",
    component: BookingHome,
  },
  {
    path: `/:lang([a-zA-Z-]+)?${import.meta.env.VITE_BASE_URL}/booking-by-centers`,
    name: "BookingByCenters",
    component: BookingFunnel,
  },
  {
    path: `/:lang([a-zA-Z-]+)?${import.meta.env.VITE_BASE_URL}/booking-by-services`,
    name: "BookingByServices",
    component: BookingFunnel,
  },
  {
    path: `/:lang([a-zA-Z-]+)?${import.meta.env.VITE_BASE_URL}/booking-no-center-available`,
    name: "NoCenterAvailable",
    component: NoCenterAvailable,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp(App);

app.use(villusClient);
app.use(naive);
app.use(router);

const pinia = createPinia();
app.use(pinia);
setActivePinia(pinia);

app.mount("#booking-app");
